export default __webpack_public_path__ + "static/media/iNOVA.d90007c0.png";